module.exports = __webpack_public_path__ + "static/1.0_1440x540_Desktop_Hero_1X-392234e0e55f6a05393d23d336add1ae.png";